module.exports = __webpack_public_path__ + "img/LogoLogin.f7c4fadb.png";